
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/finance/whatsapp",
      function () {
        return require("private-next-pages/industry/finance/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/finance/whatsapp"])
      });
    }
  